import { getCurrentOrUpcomingSchoolHoliday, getCurrentSchoolHoliday } from '../../../common/helpers/schoolHolidays';
import { getCurrentSchoolTerm, getNextSchoolTerm } from '../../../common/helpers/schoolTerms';
import api from '../../../legacy/api';
import { SchoolHolidayTerm } from '../../../legacy/types';

const useSchoolPeriods = () => {
  const { data: termsAndHolidays } = api.schoolTerm.holidays.useQuery();

  const currentSchoolTerm = getCurrentSchoolTerm((termsAndHolidays as SchoolHolidayTerm[]) || []);
  const nextSchoolTerm = getNextSchoolTerm((termsAndHolidays as SchoolHolidayTerm[]) || []);
  const currentOrUpcomingHoliday = getCurrentOrUpcomingSchoolHoliday((termsAndHolidays as SchoolHolidayTerm[]) || []);
  const currentHoliday = getCurrentSchoolHoliday((termsAndHolidays as SchoolHolidayTerm[]) || []);
  return {
    currentSchoolTerm,
    currentOrUpcomingHoliday,
    currentHoliday,
    nextSchoolTerm,
  };
};

export default useSchoolPeriods;
